// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WOnsd","title":"styles_title__8umMU","topicList":"styles_topicList__z6B7N"};